"use strict";

var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _useQuestionAnswer = require("../../hooks/use-question-answer");
var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _Dropdown = require("./Dropdown");
var _Dropdown2 = _interopRequireDefault(_Dropdown);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (_ref) {
  var question = _ref.question,
    onChangeAnswer = _ref.onChangeAnswer;
  var multiple = question.type === "multiple-dropdown";
  var _ref2 = (0, _useQuestionAnswer2.default)(question, onChangeAnswer, multiple ? [] : undefined),
    _ref3 = _slicedToArray(_ref2, 2),
    _ref3$ = _ref3[0],
    answer = _ref3$.answer,
    error = _ref3$.error,
    changeAnswer = _ref3[1];
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer !== undefined,
    error: error
  }, _react2.default.createElement(_Dropdown2.default, {
    id: question.id ? question.id : "",
    answer: answer,
    multiple: multiple,
    choices: question.choices,
    changeAnswer: changeAnswer
  }));
};